import HttpRequest from "../request";
import type { IHomePageConfig, IRoleRights, Roles, ILanguage } from "./types";
import { BasicApi, ConfigApi } from "../api";
import type { Response } from "../request";

export default {
    getHomePageConfig(): Promise<Response<IHomePageConfig>> {
        return HttpRequest.get(ConfigApi.getHomePageConfig, null)
    },
    // 获取所有角色权益
    getRoleRights(): Promise<Response<Record<Roles, IRoleRights>>> {   
        return HttpRequest.get(BasicApi.getEnterpriseConfig, null)
    },
    getLocalLanguage(langCode: string): Promise<Response<string>> {
        return HttpRequest.get(BasicApi.getLocalLanguage, {langCode: langCode, bizModelFlag: true})
    },
    // 获取语言列表
    getLanguages(): Promise<Response<ILanguage[]>> {
        return HttpRequest.get(BasicApi.getLanguages, null)
    },
    // 获取当前位置
    getCurrentLocation(): Promise<Response<string>> {
        return HttpRequest.get(BasicApi.getCurrentLocation, null)
    }
}